(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector("[data-back-to-top]");

    if (!button) {
      return;
    }

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let lastScrollY = Math.max(window.scrollY, 0);
    let ticking = false;

    const updateVisibility = () => {
      const currentScrollY = Math.max(window.scrollY, 0);
      const isPastFirstScreen = currentScrollY > window.innerHeight * 0.7;
      const isScrollingUp = currentScrollY < lastScrollY;

      button.classList.toggle("is-visible", isPastFirstScreen && isScrollingUp);
      lastScrollY = currentScrollY;
      ticking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateVisibility);
          ticking = true;
        }
      },
      { passive: true },
    );

    button.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: reduceMotion.matches ? "auto" : "smooth",
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
